import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  income: Yup.number().integer().required(),
  assets: Yup.number().integer().required(),
});
